import { NORMAL_ON_EXAM } from "@scribenote/utils";
import { Controller } from "react-hook-form";

import { BAR } from "../../../constants";
import PredictiveInput from "../../common/inputs/PredictiveInput";

export default function ObjectiveFieldItem({
  fieldName,
  fieldLabel,
  control,
  formFieldValue,
  dataTestId,
  placeholder = null,
  isForSOAPForm = true,
  isForOnboarding = false,
}) {
  const styles = isForSOAPForm
    ? "border-pink-200 text-pink-500"
    : isForOnboarding
      ? "border-gray-100 text-white"
      : "border-gray-200";
  return (
    <div className="flex flex-row items-end dark:border-gray-600 space-x-4 space-y-1 w-full">
      <h3
        className={`${styles} w-32 overflow-hidden text-ellipsis border-b dark:border-gray-500 text-xs`}
      >
        {fieldLabel}
      </h3>
      <div className="flex flex-1 flex-row items-end space-x-4">
        <div
          className={`${
            isForSOAPForm ? "border-pink-200" : "border-gray-200"
          } flex flex-1 flex-row border-b  dark:border-gray-500`}
          data-testid={dataTestId}
        >
          <Controller
            name={formFieldValue}
            control={control}
            render={({ field }) => (
              <PredictiveInput
                inputClassName={`w-full shrink-0 px-2 font-normal text-xs bg-transparent resize-none ${
                  isForOnboarding && "text-white"
                }`}
                placeholder={
                  placeholder
                    ? placeholder
                    : fieldName !== "overall"
                      ? NORMAL_ON_EXAM
                      : BAR
                }
                field={field}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
